export const meta = {
  id: 'library-sort',
  name: 'Library Sort',
  category: 'Sorting',
  complexity: {
    time: 'O(n log n)',
    space: 'O(n)'
  },
  description: 'Library Sort is an insertion-based sorting algorithm that leaves gaps between elements to allow efficient insertions, achieving O(n log n) average time.'
};
